import { useFeatureIsOn, useFeatureValue } from 'src/common/growthbook';
import type { UserData } from 'src/common/interfaces';
import { useGetUserQuery } from 'src/common/slices';
import { useGetBadgesQuery } from 'src/features/badges/badges.slice';
import type { RoomDetailsData } from 'src/features/room/room.types';

export const useShouldPromotePremium = (room?: RoomDetailsData) => {
  const userQuery = useGetUserQuery();
  const isFeatureFlagOn = useFeatureIsOn('promote-premium-on-congratulations-experiment');

  const user = userQuery?.data?.data?.user;

  const isEnabled = isFeatureFlagOn && isFreeUser(user) && isFreeRoom(room);
  const isLoading = userQuery.isLoading || !room;

  return { isEnabled, isLoading };
};

export const useShouldShareBadges = (room?: RoomDetailsData) => {
  const badgesQuery = useGetBadgesQuery();

  const awardedBadge = badgesQuery.data?.data?.badges?.find((badge) => badge.toEarn?.includes(room?.code ?? ''));

  return { awardedBadge, isLoading: badgesQuery.isLoading };
};

const isFreeRoom = (room?: RoomDetailsData): boolean => !!room && room.freeToUse;

const isFreeUser = (user?: UserData['user']): boolean =>
  !!user && !user.subscriptions.some((sub) => sub.status === 'active');

export const isFirstFourRooms = (room?: RoomDetailsData): boolean =>
  !!room &&
  [
    'trywinme',
    'offensivesecurityintro',
    'defensivesecurityintro',
    'searchskills',
    'careersincyber',
    'whatisnetworking',
  ].includes(room.code);

export const useIsPostRoomCompletionFeedbackEnabled = (roomCode?: string) => {
  const isFeatureFlagOn = useFeatureIsOn('post-room-completion-feedback-by-echo');
  const roomsObject = useFeatureValue('post-room-completion-feedback-by-echo-eligible-rooms', { list: [] });
  const rooms = Array.isArray(roomsObject?.list) ? roomsObject.list : [];

  const isEnabled = isFeatureFlagOn && rooms.includes(roomCode ?? '');

  return { isEnabled };
};
